<ll-toolnavbar></ll-toolnavbar>
<ll-titulo>Instrumentos</ll-titulo>

<mis-instrumentos listRoute="instrumentos"></mis-instrumentos>
